import React, { Fragment, useState} from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faBullhorn, faMagnifyingGlass, faBook, faClipboardList, faUserShield, faFileCircleXmark, faClipboardQuestion, faChartBar } from '@fortawesome/free-solid-svg-icons'
import '../../styles/diario.scss';


function OuvidHome() {
    const [direct, setDirect] = useState(false);

    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    } else {
        return (
            <Fragment>
                <Container>
                    <Row xs={1} lg={2}>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ouvidoria/cadastrar')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faBullhorn} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Fazer Requisição</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ouvidoria/listar')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faMagnifyingGlass} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Consultar Requisição</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ouvidoria/estatisticas')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faDatabase} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Estatísticas e Relatórios</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ouvidoria/manuais')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faBook} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Tutoriais</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/pesquisa')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faClipboardQuestion} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Pesquisa de Satisfação</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/pesquisa/resultados')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faChartBar} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Resultados das Pesquisas de Satisfação</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ouvidoria/publicas')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faClipboardList} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Todas Requisições</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ouvidoria/sigilo')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faUserShield} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Informações com sigilo</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ouvidoria/desclassificadas')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faFileCircleXmark} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Informações Desclassificadas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Link to={'/'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
                </Container>
            </Fragment>
        );
    }
}

export default OuvidHome;